import api from "@helpers/api";

import { URLS } from "@constants/urls";

import { AttendanceSummaryType } from "@type/HRM/attendance-summary";

const apiEndPointBaseURL = `${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_URL}${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_FUNCTIONALITY_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/${URLS.ATTENDANCE}`;

export const getAttendances = (() => {
  return async ({ payload }: any): Promise<any> => {
    const { page, size, date, attendanceStatusID } = payload;

    return api
      .get(
        `${apiEndPointBaseURL}?page=${page}&size=${size}&date=${date}&statusId=${attendanceStatusID}`,
      )
      .then((response) => {
        const { data, page, size, total } = response.data;

        return {
          data,
          pagination: {
            page,
            size,
            total,
          },
        };
      });
  };
})();

export const getAttendanceSummary = (() => {
  return async (
    from: string,
    to: string,
  ): Promise<{ data: AttendanceSummaryType[] }> => {
    const apiEndPoint = `http://127.0.0.1:7077/attendance/summary-info?from=${from}&to=${to}`; //!!! Spec Data

    return api.get(apiEndPoint).then((response) => {
      return { data: response.data.summaries };
    });
  };
})();
